import React, { useEffect, useState } from "react";
import "./ListarVinculos.css";

function ListarVinculos() {
  const [vinculos, setVinculos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchVinculos() {
      try {
        const response = await fetch(
          "https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_todos_vinculos.php",
          { credentials: "include" }
        );
        const data = await response.json();
        if (data.success) {
          setVinculos(data.data);
        } else {
          setError(data.error || "Erro ao listar vínculos.");
        }
      } catch (err) {
        console.error("Erro ao buscar vínculos:", err);
        setError("Erro ao conectar ao servidor.");
      } finally {
        setLoading(false);
      }
    }

    fetchVinculos();
  }, []);

  if (loading) return <p>Carregando vínculos...</p>;

  if (error) return <p className="error-message">{error}</p>;

  return (
    <div className="listar-container">
      <h1>Lista de Vínculos Meta</h1>

      {vinculos.length === 0 ? (
        <p>Nenhum vínculo encontrado.</p>
      ) : (
        <div className="table-container">
          <table className="vinculos-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuário ID</th>
                <th>Página Facebook</th>
                <th>Conta Anúncio</th>
                <th>Instagram</th>
                <th>Data Criação</th>
              </tr>
            </thead>
            <tbody>
              {vinculos.map((vinculo) => (
                <tr key={vinculo.id}>
                  <td>{vinculo.id}</td>
                  <td>{vinculo.usuario_id}</td>
                  <td>{vinculo.facebook_page_name || "-"}</td>
                  <td>{vinculo.ad_account_name || "-"}</td>
                  <td>{vinculo.instagram_username || "-"}</td>
                  <td>{new Date(vinculo.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ListarVinculos;
